import { useRef } from "react";
import useFixedBottomViewportSync from "./useFixedBottomViewportSync";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function StickyBottomActions({
  as: Component = "footer",
  className = "",
  innerClassName = "",
  children,
  ...props
}) {
  const layerRef = useRef(null);
  // Keeps the fixed layer on the real viewport bottom after the iOS keyboard
  // closes (presentation only; see the hook).
  useFixedBottomViewportSync(layerRef);

  return (
    <Component
      {...props}
      ref={layerRef}
      className={joinClassNames("lz-v2-sticky-actions", className)}
    >
      <div className={joinClassNames("lz-v2-sticky-actions__inner", innerClassName)}>
        {children}
      </div>
    </Component>
  );
}
